export enum FlaggedContentType {
  PHOTO = "Photo",
  VIDEO = "Video",
  MESSAGE = "Message",
  COMMENT = "Comment",
}

export enum FlaggedContentStatus {
  PENDING = "Pending",
  UNDER_REVIEW = "UnderReview",
  APPROVED = "Approved",
  REJECTED = "Rejected",
}

export interface FlaggedContentFlag {
  id: number
  reason: string
  reasonDetails: string | null
  status: FlaggedContentStatus
  reviewedByUserId: string
  reviewedByName?: string
  reviewedAt?: Date
  reviewNotes: string | null
  reporterName: string
  dateCreated: Date
}

export class FlaggedContent {
  public contentId?: number
  public contentType?: FlaggedContentType
  public totalFlagCount?: number
  public status?: FlaggedContentStatus
  public firstFlaggedDate?: Date
  public lastFlaggedDate?: Date
  public contentBy?: string
  public reasons?: string[]
  public previewUrl?: string
  public message?: string
  public comment?: string
  public flags?: FlaggedContentFlag[]

  constructor(flaggedContent: Partial<FlaggedContent>) {
    this.contentId = flaggedContent.contentId
    this.contentType = flaggedContent.contentType
    this.totalFlagCount = flaggedContent.totalFlagCount
    this.status = flaggedContent.status
    this.firstFlaggedDate = flaggedContent.firstFlaggedDate
    this.lastFlaggedDate = flaggedContent.lastFlaggedDate
    this.contentBy = flaggedContent.contentBy
    this.reasons = flaggedContent.reasons
    this.previewUrl = flaggedContent.previewUrl
    this.message = flaggedContent.message
    this.comment = flaggedContent.comment
    this.flags = flaggedContent.flags
  }
}
